import React from "react";
import Select from "react-select";

const SelectField = ({ label, value, onChange, options, error, required, disabled }) => {
  const customStyles = {
    control: (base, state) => ({
      ...base,
      borderRadius: "8px",
      paddingLeft: "2px",
      minHeight: "50px",
      opacity: state.isDisabled ? 0.5 : 1,
      backgroundColor: state.isDisabled ? "#e9ecef" : "white",
      boxShadow: state.isFocused
        ? error
          ? "0 0 0 0.25rem rgba(220,53,69,.25)" // red shadow like bootstrap
          : "0 0 0 0.25rem rgba(255,193,7,.25)" // your yellow focus shadow
        : "none",
      borderColor: error
        ? "#dc3545" // RED border when error
        : state.isFocused
          ? "#ffc107"
          : "#ced4da",

      "&:hover": {
        borderColor: error ? "#dc3545" : "#ffc107",
      },
    }),

    menu: (base) => ({
      ...base,
      borderRadius: "8px",
      overflow: "hidden",
      zIndex: 9999,
    }),

    menuPortal: (base) => ({
      ...base,
      zIndex: 9999,
    }),
  };

  const menuPortalTarget =
    typeof document !== "undefined" ? document.body : null;

  return (
    <div>
      {label && (
        <label className="form-label">
          {label} {required && <span className="text-danger">*</span>}
        </label>
      )}

      <Select
        isDisabled={disabled}
        value={value}
        onChange={onChange}
        options={options}
        styles={customStyles}
        classNamePrefix="react-select"
        placeholder="Select option"
        menuPortalTarget={menuPortalTarget}
        menuPosition="fixed"
        onKeyDown={(e) => {
          if (e.key === "Enter" && value) {
            onChange(value); // confirm selection
          }
        }}
      />

      {error && <div className="text-danger small mt-1">{error}</div>}
    </div>
  );
};

export default SelectField;
